module.exports = __webpack_public_path__ + "icon_chart_revert.47eaceee38b867bf58e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_chart_revert.svg
// module id = ./src/assets/img/icon_chart_revert.svg
// module chunks = main